var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83333 5.37117V16.087C5.83335 16.8552 6.023 17.6115 6.38547 18.2888C6.74794 18.9662 7.27201 19.5435 7.91117 19.9697L14 24.0297L20.0888 19.9697C20.7278 19.5436 21.2518 18.9664 21.6143 18.2894C21.9767 17.6123 22.1665 16.8562 22.1667 16.0882V5.37117L14 3.55817L5.83333 5.37117ZM4.4135 3.29684L14 1.1665L23.5865 3.29684C23.8456 3.35443 24.0773 3.49863 24.2433 3.70564C24.4094 3.91266 24.5 4.17011 24.5 4.4355V16.087C24.4999 17.2394 24.2153 18.3739 23.6715 19.3898C23.1277 20.4058 22.3415 21.2718 21.3827 21.911L14 26.8332L6.61733 21.911C5.65865 21.2719 4.87254 20.4061 4.32874 19.3904C3.78494 18.3746 3.50028 17.2403 3.5 16.0882V4.4355C3.50005 4.17011 3.59058 3.91266 3.75665 3.70564C3.92273 3.49863 4.15443 3.35443 4.4135 3.29684ZM14 15.7498L10.5712 17.5523L11.2257 13.735L8.4525 11.0307L12.2862 10.473L14 6.99984L15.715 10.473L19.5475 11.0307L16.7743 13.735L17.4277 17.5523L14 15.7498Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecure);
export default __webpack_public_path__ + "static/media/Secure.ed45b3393dc0a4a892f96d36f15c076c.svg";
export { ForwardRef as ReactComponent };